<template>
  <div class="block">
    <textarea
        :placeholder="placeholder"
        :value="modelValue"
        @input="onInput"
        class="block__textarea"
    />
    <p v-if="!validate" class="block__error">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import {ref} from "vue";

const $emit = defineEmits()
const props = defineProps({
  placeholder: String,
  isError: Boolean,
  error: String,
  modelValue: [String, Number],
  rules: Array
})

const validate = ref(true)
const errorMessage = ref('')
const onInput = (e) => {
  let result = true

  props.rules?.forEach((rule) => {
    result = rule((e.target).value)

    if (result !== true) {
      errorMessage.value = String(result)
      result = false
    }
  })

  validate.value = result

  return $emit('update:modelValue', (e.target).value)
}
</script>

<style lang="scss" scoped>
.block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  position: relative;

  &__textarea {
    width: 100%;
    height: 150px;
    resize: none;
    background-color: #f5f9fe;
    border-radius: 14px;
    padding: 15px 20px;

    color: #7c8ba0;
    font-size: 18px;

    &::placeholder {
      color: #a5b9d0;
    }
  }
}
</style>